// src/store/store.js
import { configureStore } from '@reduxjs/toolkit';
import { roleReducer } from './slices/roleSlice';
import { userReducer } from './slices/userSlice';
import { permissionReducer } from './slices/permissionSlice';
import { accountReducer } from './slices/accountSlice';
import { toastReducer } from "./slices/toastSlice";

export const store = configureStore({
    reducer: {
        role: roleReducer,
        user: userReducer,
        permission: permissionReducer,
        toast: toastReducer,
        account: accountReducer
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});